import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import { customTheme } from '../theme/customTheme';
import logoSrc from '../assets/Optum-Rx-ora-RGB.svg';
import Footer from '../components/Footer';
import LoginHeader from '../components/LoginHeader';
import { getNavigation, setAuthType, redirectToLogin } from '../api';
import { createLogger } from '../utils/logging';

const logger = createLogger('LoginPage');

export default function Login() {

  const handleMsidLogin = async (): Promise<void> => {
    try {
      // Load navigation config to check authentication settings
      await getNavigation();
      
      const query = new URLSearchParams(window.location.search);
      const code = query.get('code');
      
      if (!sessionStorage.getItem('sessionId') && !code) {
        setAuthType('msid');
        redirectToLogin('msid');
      }
    } catch (error) {
      logger.error('MSID Login Failed', 'Error during MSID authentication', { error });
    }
  };

  const handleOhidLogin = async (): Promise<void> => {
    try {
      // Load navigation config to check authentication settings
      await getNavigation();
      
      const query = new URLSearchParams(window.location.search);
      const code = query.get('code');
      
      if (!sessionStorage.getItem('sessionId') && !code) {
        setAuthType('ohid');
        redirectToLogin('ohid');
      }
    } catch (error) {
      logger.error('OHID Login Failed', 'Error during OHID authentication', { error });
    }
  };

  return (
    <ThemeProvider theme={customTheme}>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#FAF8F2',
        }}
      >
        <LoginHeader logoSrc={logoSrc} />

        <Container
          maxWidth="md"
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            py: 6,
          }}
        >
          <Paper
            elevation={0}
            sx={{
              width: '100%',
              p: { xs: 3, sm: 5 },
              borderRadius: 6
            }}
          >
            <Stack spacing={3} alignItems="center" textAlign="center">
              <Typography variant="h4" component="h1" sx={{ fontWeight: 700, color: '#002677' }}>
                Welcome to Advanced Claim View
              </Typography>

              <Typography variant="body1" color="text.secondary">
                This site allows employers and plan sponsors to manage their members.
              </Typography>

              <Box>
                <Typography variant="body1" color="text.secondary">
                  OptumRx benefits. Sign in using your MSID/OHID.
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  If you are unable to login using your credentials, contact your OptumRx client management or helpdesk representative.
                </Typography>
              </Box>

              <Stack spacing={2} sx={{ width: '100%', maxWidth: 300 }}>
                <Button variant="contained" onClick={handleOhidLogin}>
                  One Healthcare ID login
                </Button>
                <Button variant="contained" onClick={handleMsidLogin}>
                  Employee MSID login
                </Button>
              </Stack>
            </Stack>
          </Paper>
        </Container>

        <Box sx={{ mt: 'auto' }}>
          <Footer />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
